import * as React from 'react';
import { inputFormatters, inputMasks } from '@blend/ui-common';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import DataInput from '../DataInput';

class DateInput extends React.Component<InputProps, {}> {
  // @ts-ignore
  private inputProps: DirectInputProps;
  // @ts-ignore
  private contextProps: DataInputContextProps;

  render() {
    const { input, meta, label } = this.props;
    this.inputProps = {
      ...input,
      id: getIdFromName(input.name),
      type: 'tel',
    };

    this.contextProps = {
      label: label || /* istanbul ignore next: (UI-5482) */ '',
      normalize: inputFormatters.DATE.normalize,
      format: inputFormatters.DATE.format,
      error: meta.touched && meta.error,
      mask: inputMasks.DATE.maskedInputConfig as any,
    };

    return (
      <div className="DateInput">
        <DataInput inputProps={this.inputProps} contextProps={this.contextProps} />
      </div>
    );
  }
}

export const DateInputConfig = {
  component: DateInput,
};

export default DateInput;
